define('widgets/dgrid/utils/DGridData',[
    'underscore',
    'knockout'
], function (_, ko) {

    var DGridData = function (session) {
        var self = this;

        self.recommendedGames = ko.deferredComputedArray(function() {
            return session.getAssociatedPlayer().recommendedGames();
        });

        self.lastPlayedGames = ko.deferredComputedArray(function() {
            return session.getAssociatedPlayer().latestPlayedGameIds();
        });
    };

    return DGridData;
});

